import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

import { GameType } from '../../../models/communication/app-enums.model';
import { GameLabelPipe } from '../../../pipes/game-label.pipe';

@Component({
    selector: 'app-game-selection',
    standalone: true,
    imports: [CommonModule, GameLabelPipe],
    templateUrl: './game-selection.component.html',
    styleUrl: './game-selection.component.scss'
})
export class GameSelectionComponent {
    @Input()
    games?: GameType[];

    @Input()
    currentGame?: GameType;

    @Input()
    showBackButton = true;

    @Output()
    readonly backClicked = new EventEmitter();

    @Output()
    readonly gameSelected = new EventEmitter<GameType>();
}
